import PreviewElement from '../PreviewElement';

export default class SectionElement extends PreviewElement {
  injectSessionData(page): void {
    page.section.push({
      name: this.element.content.metaInfo.sectionName,
      variant: this.element.content.content.variant
    });
  }
}
